import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import packageJson from '../package.json'
import App from './App'
import { store } from './app/store'
import reportWebVitals from './reportWebVitals'
import './styles/icons/style.css'
import './styles/scss/index.scss'

const currentVersion = localStorage.getItem('version')
if (currentVersion !== packageJson.version) {
  localStorage.clear()
  localStorage.setItem('version', packageJson.version)
  window.location.reload(true)
}

const container = document.getElementById('root')
const root = createRoot(container)

// Prevent click-jacking
// if (window.self === window.top) {
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
